export default __webpack_public_path__ + "static/media/logo.a7d46d53.png";